import { AgentType } from 'mbs-ui-shared@models/Computer';
import { RemoteCommandType } from 'mbs-ui-shared@models/rm/remote-command-model';

export const AsyncAgentMinVersion = [
  {
    commandType: RemoteCommandType.ForceUpdate,
    agents: [
      {
        agentType: AgentType.Backup,
        minVersion: 800
      }
    ]
  },
  {
    commandType: RemoteCommandType.InstallApp,
    agents: [
      {
        agentType: AgentType.RA,
        minVersion: 401
      }
    ]
  }
];
